import React from 'react'

export default function NoPage() {
  return (
    <div className="no-page">
        <p>This page cannot be found</p>
    </div>
  )
}
